<template>
    <v-speed-dial
        v-model="fab"
        :open-on-hover="false"
        :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'"
        :transition="
            $vuetify.breakpoint.smAndDown
                ? 'slide-y-transition'
                : 'slide-x-transition'
        "
        absolute
    >
        <template v-slot:activator>
            <v-btn v-model="fab" icon>
                <v-icon large>
                    {{
                        $vuetify.breakpoint.smAndDown
                            ? 'mdi-dots-horizontal'
                            : 'mdi-dots-vertical'
                    }}
                </v-icon>
            </v-btn>
        </template>
        <v-btn large fab color="orange" @click="openFilterDialog">
            <v-icon color="white" size="35">mdi-magnify</v-icon>
        </v-btn>
        <v-btn large fab color="indigo" @click="openDateFilter">
            <v-icon color="white" size="35">mdi-calendar</v-icon>
        </v-btn>
        <v-btn large fab color="blue" @click="openModHeadersTableDialog">
            <v-icon color="white" size="35">mdi-pencil</v-icon>
        </v-btn>
        <v-btn large color="purple" fab @click="downloadImage">
            <v-icon color="white" size="35"> mdi-camera </v-icon>
        </v-btn>
        <v-btn large color="deep-purple" dark fab @click="openInfo">
            <v-icon size="35">mdi-information-outline</v-icon>
        </v-btn>
    </v-speed-dial>
</template>

<script>
export default {
    name: 'Dial',
    data: () => ({
        fab: false,
    }),
    computed: {},
    methods: {
        openDateFilter() {
            this.$store.commit('reportTable/isOpenReportDateFilter', true);
        },
        openInfo() {
            this.$store.commit('util/isOpenLegendDialog', true);
        },
        openFilterDialog() {
            this.$store.commit('reportTable/isOpenComercialFilterDialog', true);
        },
        openModHeadersTableDialog() {
            this.$store.commit('gerencia/isOpenModHeadersDialog', true);
        },
        downloadImage() {
            let obj = {
                elementId: 'reportTable',
                downloadName: 'Tabla reporte',
            };

            this.$store.dispatch('util/printThis', obj);
        },
    },
};
</script>
